import React from 'react'
import { ProductListGeneric } from '@zyn-common/components'

const ProductListUpSell = ({ products, translations, ...rest }) => {
  return (
    <ProductListGeneric
      title={translations.tk_upSell}
      isBundleList
      products={products}
      translations={translations}
      {...rest}
    />
  )
}

export default ProductListUpSell
